<template>
  <div>
    <QuestionStatisticsDialog
      :question="display_statistics_for_question"
      :event="event"
      :total_active_voters="totalActiveVoters"
      :quorum_value="event.quorum_value"
      :quorum="event.quorum"
      :show_results_while_active="event.results_in_progress"
      v-on:get-question="getQuestion"
      v-model="statistics_dialog_open"
    ></QuestionStatisticsDialog>
    <h6 class="title font-weight-black mb-3">
      {{ $t('components.eventTabQuestionsAndStatistics.questions') }}
    </h6>
    <div class="mb-4">
      <v-btn
        @click.stop="enable_question_form = true"
        class="ml-0"
        color="primary"
        slot="activator"
        small
        v-if="event.status !== 'completed' && event.status !== 'archive'"
      >
        <v-icon small>fa-plus fa-fw</v-icon>
        {{ $t('buttons.addQuestion') }}
      </v-btn>

      <v-btn
        @click="loadBallotFromAnotherEvent"
        color="info"
        slot="activator"
        small
        v-if="numberOfOtherEvents > 0 && event.status == 'draft'"
      >
        <v-icon small>fa-chart-bar fa-fw</v-icon>
        {{ $t('buttons.loadBallot') }}
      </v-btn>
    </div>
    <div>
      <v-flex>
        <QuestionList
          v-bind:event="event"
          v-bind:editable="editable"
          v-on:display-statistics="displayStatisticsForQuestion"
        ></QuestionList>
        <QuestionCreate
          v-if="event.status !== 'completed' && event.status !== 'archive'"
          v-model="enable_question_form"
          v-bind:quorum="event.quorum"
          v-on:question-store="handleQuestionStore"
        ></QuestionCreate>
      </v-flex>
    </div>
  </div>
</template>

<script>
import QuestionCreate from '@/components/QuestionCreate.vue'
import QuestionList from '@/components/QuestionList.vue'
import QuestionStatisticsDialog from '@/components/QuestionStatisticsDialog.vue'
import Question from '@/models/Question.js'
import get_index_by_id from '@/helpers/get_index_by_id.js'
import handle_session_error from '@/helpers/handle_session_error.js'
import get_question_order_number from '@/helpers/get_question_order_number.js'

export default {
  components: {
    QuestionCreate,
    QuestionList,
    QuestionStatisticsDialog,
  },

  props: ['editable', 'event', 'numberOfOtherEvents'],

  data() {
    return {
      enable_question_form: false,
      display_statistics_for_question: null,
      statistics_dialog_open: false,
    }
  },

  computed: {
    totalActiveVoters() {
      let activeVoters = 0

      for (const voter of this.event.voters.filter(v => v.active)) {
        if (voter.authorizers.length > 0) {
          activeVoters += voter.authorizers.length
        } else {
          activeVoters++
        }
      }

      return activeVoters
    },
  },

  methods: {
    getQuestion(question) {
      this.$APICall(
        'get',
        'QUESTIONS',
        `/${question.id}`,
        [],
        data => {
          const index = get_index_by_id(this.event.questions, question.id)

          if (index !== false) {
            this.event.questions.splice(index, 1, new Question(data.data))
            this.display_statistics_for_question = this.event.questions[index]
          } else {
            throw new Error(
              this.$t(
                'components.eventTabQuestionsAndStatistics.errors.questionNotFound'
              )
            )
          }
        },
        true,
        error => {
          handle_session_error(error, this.$store, this.$router, this.$prompt)
        }
      )
    },

    displayStatisticsForQuestion(question) {
      this.display_statistics_for_question = question
      this.statistics_dialog_open = true
    },

    loadBallotFromAnotherEvent() {
      this.$emit('old-event-load-dialog-reset', 'ballot')
      this.$emit('old-event-load-dialog-show', true)
    },

    handleQuestionStore(question) {
      if (this.event.status === 'active' || this.event.status === 'published') {
        // Adds event_id to question.
        question.event_id = this.event.id

        // Removes empty answers.
        question.answers = question.answers.filter(answer => {
          return answer.label !== ''
        })

        this.$APICall(
          'post',
          'QUESTIONS',
          '',
          question,
          data => {
            this.event.questions.push(new Question(data.data))
          },
          true,
          error => {
            handle_session_error(error, this.$store, this.$router, this.$prompt)
          }
        )
      } else {
        // Generates the date in the same format as the API.
        question.created_at = new Date().toISOString()
        // This should be unique enough.
        question.id = question.created_at
        // Gets max order number or null.
        question.order = get_question_order_number(this.event.questions)

        this.event.questions.push(question)
      }
    },
  },
}
</script>
